import LegalPage from "../components/LegalPage";

const SECTIONS = [
    {
        heading: "Overview",
        body: [
            "This Privacy Policy explains how SahiKhoj (“we”, “our”, “the app”) approaches information in connection with the SahiKhoj mobile application and the sahikhoj.com website.",
            "The sahikhoj.com website is informational only. It does not include sign-up forms, accounts, payments or search functionality, and it is not designed to collect personal information from visitors.",
        ],
    },
    {
        heading: "Information you may provide",
        body: [
            "If you contact us by email (for example, for support or a data deletion request), we will receive the information you choose to share, such as your email address and the contents of your message. We use this information only to respond to and resolve your request.",
        ],
    },
    {
        heading: "Account information",
        body: [
            "Where the SahiKhoj mobile app offers account creation, the app may ask for basic account details such as your name, email address or mobile number. This information is used to create and manage your account and to provide app features.",
            "If account functionality is not enabled in the version of the app you use, no account information is collected.",
        ],
    },
    {
        heading: "Technical and device information",
        body: [
            "Where applicable, the app may process standard technical information such as device model, operating system version, app version and basic diagnostic data. This helps us keep the app working reliably across devices.",
            "Like most websites, our hosting infrastructure may record standard technical logs (such as IP address and browser type) for security and operational purposes.",
        ],
    },
    {
        heading: "How information may be used",
        body: [
            "Information described above may be used to: provide and maintain the app's features; respond to support and deletion requests; improve the reliability and usability of the app; and meet legal or security obligations.",
            "We do not sell your personal information.",
        ],
    },
    {
        heading: "Third-party services",
        body: [
            "SahiKhoj surfaces information from third-party platforms and merchants. When you follow a link to a third-party platform, that platform's own privacy policy applies to any information you share with it.",
            "We encourage you to review the privacy policies of any third-party platform before completing a purchase or booking there.",
        ],
    },
    {
        heading: "Data security",
        body: [
            "We take reasonable technical and organisational measures to protect information under our control. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
        ],
    },
    {
        heading: "Data retention",
        body: [
            "We retain personal information only for as long as it is needed for the purposes described in this policy, or as required by applicable law. Support conversations are kept as long as needed to resolve and document your request.",
        ],
    },
    {
        heading: "Your rights",
        body: [
            "You may request access to, correction of, or deletion of your personal information associated with SahiKhoj. To request deletion of your app account and associated personal data, please use the process described on our Delete Account / Data Request page.",
            "We may need to verify your identity before acting on a request.",
        ],
    },
    {
        heading: "Policy updates",
        body: [
            "We may update this Privacy Policy from time to time. The “Last updated” date at the top of this page shows when the policy was most recently revised. Continued use of the website or app after an update means you accept the revised policy.",
        ],
    },
];

const PrivacyPolicyPage = () => (
    <LegalPage
        title="Privacy Policy"
        eyebrow="SahiKhoj Legal"
        updated="July 2026"
        description="How SahiKhoj handles information across the website and mobile app — what may be collected, how it is used, and your rights."
        path="/privacy-policy"
        intro="Your privacy matters. This policy explains, in plain language, what information SahiKhoj may handle and why."
        sections={SECTIONS}
        testId="privacy-policy-page"
    />
);

export default PrivacyPolicyPage;
